import React, {useMemo} from 'react'
import PropTypes from 'prop-types'

import {
    Flex,
    Text,
    useMediaQuery
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {contentfulMediaFormatter} from '../../../utils'
import {colors} from '../../../constants'
import Link from '../../../components/link'
import {useIntl} from 'react-intl'

const HomeArticlesCarouselCard = ({data}) => {
    const [isDesktop] = useMediaQuery('(min-width: 992px)')
    const {formatMessage} = useIntl()

    const article = data?.article?.fields
    const title = data?.title ?? article?.cardTitle
    const description = data?.description ?? article?.cardDescription
    const color = data?.theme?.color || colors.white

    const cta = data?.cta || {
        type: 'tertiary',
        url: `/pages/blog/${article?.slug}`,
        text: formatMessage({
            id: 'rennai.carousel_read_article',
            defaultMessage: 'READ ARTICLE'
        }),
        color
    }

    const image = useMemo(() => {
        const images = contentfulMediaFormatter(article?.cardImage)
        return !isDesktop && images?.mobile?.url
            ? images?.mobile
            : images?.desktop
    }, [])

    return (
        <Flex
            gap="16px"
            width="384px"
            height="480px"
            padding={{base: '20px', xl: '40px'}}
            borderRadius="24px"
            flexDirection="column"
            justifyContent="flex-end"
            background={`linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), url(${image?.url}) lightgray 50% / cover no-repeat`}
        >
            <Text
                color={color}
                fontSize="16px"
                fontFamily="Raleway"
                fontWeight="600"
                lineHeight="24px"
            >
                {title}
            </Text>
            {description && (
                <Text
                    fontSize="14px"
                    fontFamily="Raleway"
                    lineHeight="20px"
                    fontWeight="400"
                    color={color}
                >
                    {description}
                </Text>
            )}
            {cta && (
                <Link
                    {...cta}
                    classNames="read_action"
                    buttonStyles={{
                        color,
                        fontFamily: 'Roboto',
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '20px',
                        textDecorationLine: 'underline',
                        textDecorationStyle: 'solid',
                        textDecorationSkipInk: 'none',
                        textDecorationThickness: 'auto',
                        textUnderlineOffset: 'auto',
                        textUnderlinePosition: 'from-font',
                        textTransform: 'uppercase'
                    }}
                />
            )}
        </Flex>
    )
}

HomeArticlesCarouselCard.displayName = 'HomeArticlesCarouselCard'

HomeArticlesCarouselCard.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        cta: PropTypes.obj,
        article: PropTypes.shape({
            fields: PropTypes.shape({
                cardImage: PropTypes.obj,
                cardCta: PropTypes.obj,
                slug: PropTypes.string,
                cardTitle: PropTypes.string,
                cardDescription: PropTypes.string
            })
        }),
        theme: PropTypes.shape({
            color: PropTypes.obj,
            backgroundColor: PropTypes.obj
        })
    })
}

export default HomeArticlesCarouselCard
